import React from 'react'
import createComponent from '@services/react-mount-component'
import useSections from '@hooks/use-sections'

export default createComponent('.section-nav',
  () => {
    const [activeIndex,elements] = useSections();

    return (
      <ul className='section-nav-list' role='navigation'>
        {
          elements.map((section,index)=>{
            if(!section.id) return null;

            return (
              <li className='section-nav-list-item' key={index}>
                <a className={`section-nav-link ${activeIndex===index?'is-current':''}`} href={`${location.pathname}#${section.id}`}>{index + 1}</a>
              </li>
            );
          })
        }
      </ul>
    )
  }
);